import { render, staticRenderFns } from "./UnauthorisedAccessList.vue?vue&type=template&id=70d803d5"
import script from "./UnauthorisedAccessList.vue?vue&type=script&lang=js"
export * from "./UnauthorisedAccessList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports